import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { KeHoachSanXuat, KeHoachSanXuatTheoTuan, KeHoachSanXuatTuan, KeHoachSanXuatTuanCopy, KhKeHoachSanXuatDuKienNhapXuatInteraction, KhKeHoachSanXuatInteraction, NotificeDataKHSXTuan } from '../ke-hoach-san-xuat-model/ke-hoach-san-xuat.model';
const API_ROOT_URL = environment.ApiRoot + '/sanxuat';
const API_PHUONGAN_URL = environment.ApiRoot + '/phuongan';
const API_ROOT_URL_KHSXTT = environment.ApiRoot + '/khsxtheotuan';

@Injectable()
export class KeHoachSanXuatService {

	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});

	lastData$: BehaviorSubject<KhKeHoachSanXuatInteraction[]> = new BehaviorSubject([]);
	dataNew$: BehaviorSubject<number[]> = new BehaviorSubject([]);
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;

	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }


	/*-------------------------------GET Method----------------------------- */
	getDataDHB(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/KH_DonHangBan_List', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	getDataKeHoachNCC(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/KH_KeHoachNCCGiaoHang_List', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	getDataBTP(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/KH_BanThanhPham_List', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	getDataTheoDoiTienDo(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/KH_TheoDoiTienDo_List', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	getDataTienDoPO(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_PHUONGAN_URL + '/PA_TienDoPO', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	getDataTheoDoiTienDoLite(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/KH_TheoDoiTienDo_ListLite', {
			headers: httpHeaders,
			params: httpParams
		});
	}
	getDataTheoDoiTienDoById(id): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + '/KH_TheoDoiTienDo_ById?Id=' + id, { headers: httpHeaders, });
	}
	getDataTheoDoiTienDoByIdVaBOM(IdCTPO: number, IdBOM: number = -1): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/KH_TheoDoiTienDo_ByIdCTPO_BOM?IdCTPO=${IdCTPO}&IdBOM=${IdBOM}`, { headers: httpHeaders, });
	}
	getDataQTSXBaseOnTP(IdTP: number[]): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  API_ROOT_URL + `/GDSX_BaseOnTP_List` ;
		return this.http.post<any>(url , IdTP, { headers: httpHeaders });
	}
	getListNPL(item: KhKeHoachSanXuatInteraction[]): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + `/KH_GetListNPL`;
		return this.http.post<any>(url, item, { headers: httpHeaders });
	}
	getListNPL_HangHoaCT(item: KhKeHoachSanXuatDuKienNhapXuatInteraction[]): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + `/KH_GetListNPL_HangHoaCT`;
		return this.http.post<any>(url, item, { headers: httpHeaders });
	}
	getListNPLFromPhuongAn(item: KhKeHoachSanXuatInteraction[]): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + `/KH_GetListNPL_FromPhuongAn`;
		return this.http.post<any>(url, item, { headers: httpHeaders });
	}
	getTonKhoNPLFromPhuongAn(item: KhKeHoachSanXuatInteraction): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + `/KH_GetTonKhoNPL_FromPhuongAn`;
		return this.http.post<any>(url, item, { headers: httpHeaders });
	}
	getListKHSX(listID: number[]): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + `/GetListKHSX`;
		return this.http.post<any>(url, listID, { headers: httpHeaders });
	}
	getListKHSX_BaseOnListDate(listDate: any[]): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + `/GetListKHSX_BaseOnListDate`;
		return this.http.post<any>(url, listDate, { headers: httpHeaders });
	}
	getListKHSXCopy_BaseOnListDate(item: KeHoachSanXuatTuanCopy): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + `/GetListKHSXCopy_BaseOnListDate`;
		return this.http.post<any>(url, item, { headers: httpHeaders });
	}
	getListKHSX_BaseOnWeek(listDate: any[]): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_PHUONGAN_URL + `/GetListKHSX_BaseOnWeek`;
		return this.http.post<any>(url, listDate, { headers: httpHeaders });
	}
	getDataHieuSuatFromBom_BaseOnHHAndGD(IdHH: number, idGiaiDoan: number, idBOM: number = -1){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/GetDataFromBom_PA?IdHH=${IdHH}&idGiaiDoan=${idGiaiDoan}&idBOM=${idBOM}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getConfigDateDNMH(){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/GetConfigDateMH_KH`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getKHSXWeekItem(id: number){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/GetKHSXWeek_BaseOnID?id=${id}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getKHSXWeekItemByDate(from: string, to: string, idKhuvuc: number, isFilterPhieuXL: boolean = false){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/GetKHSXWeek_BaseOnDate?fromDate=${from}&toDate=${to}&idKhuvuc=${idKhuvuc}&isFilterPhieuXL=${isFilterPhieuXL}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	calculateMaterialFromBomBaseOnHHAndGD(IdHH: number, idGiaiDoan: number, SLBTPGDChinh: number, idCtDT: number = -1, idBOM: number = -1){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/calculateMaterialFromBomBaseOnHHAndGD?IdHH=${IdHH}&idGiaiDoan=${idGiaiDoan}&SLBTPGDChinh=${SLBTPGDChinh}&idCtDT=${idCtDT}&idBOM=${idBOM}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getListTP_BTPFromBOM(id: number){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_PHUONGAN_URL}/getListBTPFromBom?idBOM=${id}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	getListNPLFromBOM(idBomBTP: number){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_PHUONGAN_URL}/getListNPLFromBOM?idBomBTP=${idBomBTP}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */

	/*-------------------------------POST Method---------------------------- */
	add(item: KeHoachSanXuatTheoTuan): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/KHSX_Insert', item, { headers: httpHeaders });
	}
	sendApprove(item: KeHoachSanXuatTheoTuan): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/KHSX_SendApprove', item, { headers: httpHeaders });
	}
	cancel(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/KHSX_Cancel?Id=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	exportFileExcelKHSXTheoTuan(data: any): Observable<Blob>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<Blob>(API_ROOT_URL_KHSXTT + '/KeHoachSanXuatTheoTuan_Export', data,{
		  headers: httpHeaders,
		  responseType: 'blob' as 'json'
		});
	}
	changeBOM(item: KeHoachSanXuat){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/KH_ThayDoiBOM_TienDo', item, { headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */

	/*------------------------------ Qui trình ----------------------------- */
	xemxet(item: KhKeHoachSanXuatInteraction[]): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/KHSX_XemXet', item, { headers: httpHeaders });
	}
	xemxetKHTuan(item: KeHoachSanXuatTuan): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/KHSX_XemXetKHTuan', item, { headers: httpHeaders });
	}
	xemxetAllKHTuan(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/KHSX_XemXetKHTuan_All', item, { headers: httpHeaders });
	}
	duyet(item: KhKeHoachSanXuatInteraction[]): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/KHSX_Duyet', item, { headers: httpHeaders });
	}
	duyetKHTuan(item: KeHoachSanXuatTuan): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/KHSX_DuyetKHTuan', item, { headers: httpHeaders });
	}
	duyetAllKHTuan(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/KHSX_DuyetKHTuan_All', item, { headers: httpHeaders });
	}
	sendNotificeKHSXTheoTuan(data: NotificeDataKHSXTuan): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/KHSX_ThongBaoTheoTuan', data, { headers: httpHeaders });
	}
	huyDuyet(item: KhKeHoachSanXuatInteraction): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/KHSX_HuyKeHoachDaDuyet', item, { headers: httpHeaders });
	}
	duyetHuy(item: KhKeHoachSanXuatInteraction): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/KHSX_HuyKeHoachDaDuyet_Duyet', item, { headers: httpHeaders });
	}
	/*---------------------------------------------------------------------- */

	
}
